import { render, staticRenderFns } from "./NotificationsFilter.vue?vue&type=template&id=1a7fd895&scoped=true&"
import script from "./NotificationsFilter.vue?vue&type=script&lang=js&"
export * from "./NotificationsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7fd895",
  null
  
)

export default component.exports